<template>
	<div id="ca-dashboard">
		<h3 class="title title-page text-primary font-medium">Espace client GMD</h3>

		<div class="md-layout md-gutter" v-if="message.length > 0">
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
				<md-card class="mb-4">
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fas', 'sticky-note']" />
						</div>
						<h4 class="title font-normal">Message personnel</h4>
					</md-card-header>
					<md-card-content>
						{{ message }}
					</md-card-content>
				</md-card>
			</div>
		</div>

		<div class="md-layout md-gutter">
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fas', 'cubes']" />
						</div>
						<h4 class="title font-normal">Dernières interventions</h4>
					</md-card-header>
					<md-card-content>
						<md-list class="md-dense" v-if="previousInterventions.length > 0">
							<md-list-item v-for="intervention in previousInterventions"
								:key="intervention.id">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'check-square']" />
								<div class="md-list-item-text flex-row items-center">
									<span style="max-width: 80px">{{ $moment(intervention.date).format('DD/MM/YYYY') }}</span>
									<span>{{ intervention.type }}</span>
									<div style="width: auto; min-width: 44px;" v-if="intervention.report_url">
										<md-button class="md-icon-button md-raised md-danger" @click="getPdfReport(intervention.report_url)">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'file-pdf']" />
										</md-button>
										<md-tooltip md-direction="top">Télécharger le rapport</md-tooltip>
									</div>
								</div>
							</md-list-item>
						</md-list>
						<span v-else>Aucune intervention à afficher</span>
					</md-card-content>
				</md-card>
			</div>

			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fas', 'cubes']" />
						</div>
						<h4 class="title font-normal">Prochaines interventions</h4>
					</md-card-header>
					<md-card-content>
						<md-list class="md-dense" v-if="nextInterventions.length > 0">
							<md-list-item v-for="intervention in nextInterventions"
										  :key="intervention.id">
								<div class="mr-2">
									<font-awesome-icon class="md-icon m-0" :class="getStatusColor(intervention)" :icon="['fa', 'caret-square-right']" />
									<md-tooltip md-direction="top">{{ intervention.status_name }}</md-tooltip>
								</div>
								<div class="md-list-item-text flex-row items-center">
									<span style="max-width: 80px">{{ $moment(intervention.date).format('DD/MM/YYYY') }}</span>
									<span>{{ intervention.type }}</span>
								</div>
							</md-list-item>
						</md-list>
						<span v-else>Aucune intervention à afficher</span>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "ClientsAreaDashboard",
	data() {
		return {
			message: '',
            previousInterventions: [],
			nextInterventions: [],
		};
	},
    mounted () {
        this.fetchDashboardData()
    },
    methods: {
        async fetchDashboardData() {
            const localStorageData = JSON.parse(localStorage.getItem('client-area'))
            const { data } = await this.$store.dispatch('clientArea/fetchDashboardData', {
                access_token: localStorageData.accessToken,
                user_type: localStorageData.userType,
            })
            this.message = data.message ?? ''
            this.previousInterventions = data.interventions.previous
            this.nextInterventions = data.interventions.next
        },
        getPdfReport (url) {
            let link = document.createElement('a')
            link.setAttribute('href', url)
            link.setAttribute('target', '_blank')
            link.click()
        },
        getStatusColor(intervention) {
            let color
            switch (intervention.status_id) {
                case 1:
                    color = 'text-danger'
                    break
                case 2:
                    color = 'text-warning'
                    break
                case 3:
                    color = 'text-yellow-300'
                    break
                case 4:
                    color = 'text-success'
                    break
                default:
                    color = 'text-black'
                    break
            }
            return color
        }
    }

};
</script>
<style lang="scss" scoped>
::v-deep {
	.md-card-header-icon {
		.md-icon {
			color: #FFF;
		}
	}
	.md-list.md-dense {
		padding: 0;

		.md-list-item {
			margin-bottom: .25rem;
			margin-left: 0;
		}

		.md-list-item:last-child {
			margin-bottom: 0;
		}

		.md-list-item-content.md-ripple {
			min-height: 25px;
			padding: 0;

			.md-icon {
				font-size: .875rem !important;
				min-width: .875rem !important;
				height: .875rem !important;
			}
			.md-icon:first-child {
				margin-right: .5rem;
			}
			.md-list-item-text {
				position: relative;
				font-size: .875rem;

				.md-button {
					width: auto;
					margin: 0;

					.md-ripple {
						min-height: 25px;
						padding: 0 15px;

						.md-icon {
							color: #FFF !important;
						}
					}
				}

				.md-icon {
					font-size: .875rem !important;
					min-width: .875rem !important;
					height: .875rem !important;
					margin: 0;
				}

				a, span {
					font-size: .875rem;
				}
			}
		}
	}
}
</style>
